<template>
    <div>
        <div id="panel-description" class="panel">
            <div class="panel-hdr bg-primary-700 bg-success-gradient">
                
                <h2>{{this.protocol?.protocol_title}}</h2>
                
                <div class="panel-toolbar">
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                    </button>
                    
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>
            
            <div class="panel-container collapse show overflow-auto">
                <BOverlay key="tab" :show="is_load">
                    <div class="panel-content">
                        <protocol_info_head :protocol="protocol"></protocol_info_head>
                        <div class="currency_info">
                            <protocol_currency
                                @change_currency_type="reBuildPriceByCurrencyType"
                                :protocol="protocol">
                            </protocol_currency>
                        </div>
                    </div>
                    
                    <div class="tabs mt-2 p-3">
                        <BTabs  v-model="tabId" content-class="mt-3"     @update:index="onTabChange">
                            <BTab v-for="(tab,index) in tabs" :disabled="tab.disabled" :id="index" :title="tab.title" :active="tab.is_active"
                                  :key="index"
                            >
                                <template #title>
                                    {{tabTitle(tab)}}
                                    <BSpinner type="grow" small v-if="tab.is_load" />
                                </template>
                                
                                <component v-bind:is="tab.index" :protocol="protocol"></component>
                            </BTab>
                        </BTabs>
                    </div>
                    
                    <div class="container-fluid pb-4">
                        <div class="row">
                            <div class="col-12">
                                
                                <div class="btn btn-outline-danger  waves-effect waves-themed mr-2" >
                                    Оцінки контрагентів
                                </div>
                                
                                <div class="btn btn-primary  waves-effect waves-themed mr-2"
                                     v-on:click="saveProtocol('with_mem')">
                                    На погодження
                                </div>
                                
                                <div class="btn btn-outline-success  waves-effect waves-themed mr-2"
                                     v-on:click="saveProtocol('standart')">
                                    Зберегти
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <edit_application></edit_application>
                </BOverlay>
            </div>
        </div>
    </div>
</template>

<script>
import Protocol_info_head from "./blocks/protocol_info_head.vue";
import Protocol_currency from "./blocks/protocol_currency.vue";
import protocol_request from "./tabs/protocol_request.vue";
import protocol_description from "./tabs/protocol_description.vue";
import protocol_positions from "./tabs/protocol_positions.vue";
import protocol_positions2 from "./tabs/protocol_positions2.vue";

import protocol_winners from "./tabs/protocol_winners.vue";
import protocol_winners2 from "./tabs/protocol_winners2.vue";
import protocol_memorandum from "./tabs/protocol_memorandum.vue";


import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';
import Edit_application from "./edit/edit_application.vue";
export default {
    name: "protocol",
    components: {
        Edit_application,
        Protocol_currency,
        Protocol_info_head,
        protocol_request,
        protocol_description,
        protocol_positions,
        protocol_positions2,
        protocol_winners,
        protocol_winners2,
        protocol_memorandum,
        BTabs,
        BTab,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup
    },
    
    props: {
        protocol_id: {
            type: [Number, String],
            default : 0,
        },
        
        tender_id : {
            type: [Number, String],
            default : 0,
        }
    },
    
    data() {
        return {
            is_load: false,
            tabId : "protocol_general",
            protocol : {
                id : 0,
                rate_from_protocol : 0,
                position_grid_add : [],
                calculated_sum : {
                    cur_sum : 0,
                    opt_sum : 0,
                }
            },
            tabs : []
        }
    },
    
    created() {
        EventBus.$on('application:updated',this.loadProtocol);
        this.protocol.id = this.protocol_id;
        this.loadProtocol();
    },
    
    methods : {
        onTabChange(newIdx) {
            const active = this.default_tabs[newIdx]?.index
            EventBus.$emit('tab-shown', active)
        },
        
        clearWinners() {
            EventBus.$emit('winners:reset');
        },
        
        reBuildPriceByCurrencyType(currency_type) {
            if(this.protocol.currency_type != currency_type) {
                this.clearWinners();
                this.loadProtocol(currency_type);
            }
        },
        
        async saveProtocol(type = 'standart') {
            let  url = '/tenders/sales/tenders/' + parseInt(this.tender_id) + "/protocol" + "/" + this.protocol_id;
            this.is_load = true;
            await api.put(url,{
                'protocol' : this.protocol,
                'type' : type,
            }).then(({data}) => {
                let protocol_id = parseInt(data.data);
                if(protocol_id > 0) {
                    window.location.href = '/protokoly/edit/' + protocol_id;
                }
                
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                })
            });
        
        },
        
        async loadProtocol(currency_type = -1) {
            this.is_load = true;
            let self = this;
            let body = {
                'tender_id'     : this.tender_id,
                'protocol_id'   : this.protocol.id,
            }
            
            if(parseInt(currency_type) >= 0) {
                body['rate_from_protocol'] = currency_type;
            }
            
            
            await axios.post('/internal/protocol/getProtocol',body).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    self.protocol = data.data;
                    
                    if(!this.protocol.hasOwnProperty('position_grid_add')) {
                        self.protocol.position_grid_add = [];
                    }
                    
                    if(!self.protocol.hasOwnProperty('memorandum')) {
                        self.protocol.memorandum = {
                            'users' : [],
                            'preambula' : '',
                            'members' : [],
                            'winners' : [],
                        };
                    }
                    self.pushTabs();
                }
            }).catch(({response}) => {
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message, type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left"
                })
            });
        },
        
        async loadProtocolApi() {
            this.is_load = true;
            
            let url = '/tenders/sales/protocols/' + parseInt(this.protocol.id);
            if(parseInt(this.tender_id) > 0) {
                url = '/tenders/sales/tenders/' + parseInt(this.tender_id) + "/protocol" + "/" + this.protocol_id;
            }
            
            await api.get(url).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.protocol = data.data;
                    this.pushTabs();
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        pushTabs() {
            this.tabs = [];
            
            this.default_tabs.map(item => {
                this.tabs.push({
                    title       : item.title,
                    disabled    : item.disabled,
                    is_active   : item.is_active,
                    is_load     : false,
                    index       : item.index,
                });
            });
        },
        
        tabTitle(tab) {
            let count = 0;
            
            if(tab.index == 'protocol_winners' || tab.index =='protocol_winners2') {
                if (this.protocol.position_grid_add.length > 0) {
                    count = this.protocol.position_grid_add.reduce((sum, item) => {
                        return sum + (item.records_push.length || 0);
                    }, 0);
                }
                
                return "Переможці (" + count + ")";
            }
            
            return tab.title;
        },
    },
    
    computed : {
        is_new() {
            return parseInt(this.protocol_id) === 0;
        },
        
        tender() {
            return this.protocol?.tender;
        },
        
        tender_title() {
            return this.tender?.number + ' ' + this.tender?.name
        },
        
        default_tabs() {
            
            let def = [
                {
                    "title": "Пропозиції",
                    "index": "protocol_positions2",
                    is_active: true,
                    disabled: false,
                },
                {
                    "title": "Переможці",
                    "index": "protocol_winners2",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Заявки ",
                    "index": "protocol_request",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Опис ",
                    "index": "protocol_description",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Погодження \"Протокол тендерної комісії\" ",
                    "index": "protocol_memorandum",
                    is_active: false,
                    disabled: false,
                },
                
            ];
            
            return def;
        }
    }
}
</script>



<style scoped>

</style>